<template>
  <layout>
    <div class="w-full sm:w-1/2 mx-auto mb-0 mt-4 px-4 py-2 text-left">


      <div class="max-w-lg mb-5 border-b border-gray-200 pb-4">
        <div class="mb-2 flex items-center justify-start">
          <Link :href="route('control-panel.workshops.index')"><svg xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg></Link>
          <p class="text-lg sm:text-xl font-extralight">
            {{ headline }}</p>

            <testmode-badge :session="session" class="ml-3"></testmode-badge>
        </div>


        <progress-tabs :active-index="4" :session="session" :disable-more="false" @clicked="handleTabClick"></progress-tabs>


        <div class="px-0 py-0 sm:px-0">
          <div class="flex mb-1">
            <div class="w-1/4 text-sm font-semibold">Kunde</div>
            <div class="w-3/4 text-sm">{{ session.customer_name || '--' }}</div>
          </div>

          <div class="flex mb-1">
            <div class="w-1/4 text-sm font-semibold">Projekt</div>
            <div class="w-3/4 text-sm">{{ session.project_name || '--' }}</div>
          </div>

          <div class="flex mb-4">
            <div class="w-1/4 text-sm font-semibold">Marke</div>
            <div class="w-3/4 text-sm">{{ session.brandname || '--' }}</div>
          </div>

          <div class="flex">
            <div class="w-1/4 text-sm font-semibold">QR Code</div>
            <div class="w-3/4 text-sm">
              <span v-if="session.show_qr_code" class="text-sm"> wird angezeigt</span>
              <span v-if="!session.show_qr_code" class="text-sm">ist ausgeblendet</span>

            </div>
          </div>
        </div>

        <div v-if="session.introtext" class="text-left sm:text-center mt-4 px-5 mx-auto max-w-lg">
          <horizontal-divider></horizontal-divider>

          <p v-if="session.introtext" class="text-sm whitespace-pre-line" v-html="session.introtext"></p>
        </div>




        <div v-if="session.logo" class="mt-6 px-8">
          <session-logo :session="session"></session-logo>
          <!-- <img :src="session.session_logo_url" class="w-32"> -->
        </div>
      </div>


      <!-- <p class="mt-0 mb-2 ml-1 text-lg sm:text-xl font-extralight">
        Auswahl treffen
      </p> -->


      <!-- 

      <p class="mt-0 mb-3 ml-3 text-lg sm:text-xl font-extralight flex items-center">
        <Link :href="route('control-panel.workshops.index', { sessionUuid: session.uuid })">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-5 h-5 mr-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg></Link>

        Auswahl überprüfen
      </p> -->

      <fieldset class="mb-6 select-none">

        <p v-if="!form.phases" class="text-sm">Es wurden noch keine Fragen ausgewählt.</p>


        <draggable :list="form.phases" handle=".order-handle" class="space-y-2 flex flex-col max-w-lg"
          ghost-class="ghost" tag="div">
          <!-- Checked: "z-10 border-indigo-200 bg-indigo-50", Not Checked: "border-gray-200" -->
          <div v-for="(phase, idx) in form.phases" :key="idx"
            class="rounded-tl-md rounded-md flex cursor-pointer border focus:outline-none p-2"
            :class="itemClasses(phase)">
            <span class="flex flex-col p-1 grow">

              <span class="block text-sm" v-if="isPlaceholderQuestion(phase)">
                {{ formattedQuestion(phase) }}
              </span>

              <span v-else class="block text-sm">{{ phase.name }}</span>


              <span v-if="phase.subtitle" class="block text-sm sm:inline">{{
                phase.subtitle
                }}</span>

              <span v-if="phase?.data?.question_type == 'radio'" class="block text-xs sm:inline italic text-gray-400">{{
                phase?.data?.parameters?.choices.join(', ')
                }}</span>
            </span>

            <div class="w-12 border-l flex items-center shrink-0 justify-center order-handle cursor-move">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-5 h-5 shrink-0">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 9h16.5m-16.5 6.75h16.5" />
              </svg>
            </div>
          </div>
        </draggable>



        <!-- save as template: start -->
        <!-- <horizontal-divider />

        <div class="flex gap-x-5 items-center">
          
          <label
            class="relative block cursor-pointer rounded-lg border px-6 py-2 focus:outline-none sm:flex sm:justify-between"
            :class="form.saveAsTemplate
            ? 'bg-markencode-blue'
            : 'bg-white'
          ">
            <input type="checkbox" name="save_as_template" :value="true" class="sr-only"
              v-model="form.saveAsTemplate" />
            <span class="flex items-start">
              <span class="flex flex-col text-sm">
                <span id="session_type-0-label" class="font-medium" :class="form.saveAsTemplate
            ? 'text-white'
            : 'text-gray-900'
          ">Als Vorlage speichern</span>

              </span>
            </span>

            <span class="pointer-events-none absolute -inset-px rounded-lg border-2" aria-hidden="true"></span>
          </label>

          <input type="text" ref="templateName" v-model="form.templateName"
            class="form-input bg-white border-gray-200 border-solid focus:border-markencode-blue focus:ring-transparent px-3 py-1.5 sm:py-2 rounded-md block sm:inline w-full sm:w-64 shadow-none sm:text-sm focus:ring-markencode-blue"
            placeholder="Vorlagenname" :disabled="!form.saveAsTemplate"
            :class="!form.saveAsTemplate ? 'opacity-50' : ''">
            
        </div> -->

        <!-- save as template: end -->

      </fieldset>


      <horizontal-divider></horizontal-divider>

      <div class="px-0 py-0 sm:px-0">
          <div class="flex mb-1">
            <div class="w-1/4 text-sm font-semibold">User</div>
            <div class="w-3/4 text-sm">
              <p v-for="user in session.users" :key="user.id">
                {{  user.name  }}
              </p>
            </div>
          </div>
      </div>

      <horizontal-divider></horizontal-divider>

      <p v-if="!form.phases" class="text-sm text-markencode-red">Die Angaben für {{ session.session_type == 'diy_workshop' ? 'diese Umfrage' : 'diesen Workshop' }} sind noch nicht vollständig. Bitte pflegen Sie die Pflichtfelder unter "Hauptangaben" und "Fragen".</p>


      <div class="max-w-lg w-full flex items-end justify-end pt-4">
  
        <button type="submit" @click="submit"
          class="inline-flex justify-center bg-brandpreneurship-dark-gray w-full sm:w-min rounded-md border border-transparent px-4 py-2 sm:my-2 sm:px-2 sm:py-2 text-base leading-6 font-medium text-white shadow-sm transition ease-in-out duration-150 sm:text-sm sm:leading-5 z-50"
          :class="disabled ? 'opacity-50 cursor-default' : 'hover:bg-black focus:outline-none focus:border-black opacity-100 cursor-pointer'">
          SPEICHERN
        </button>
      </div>


    </div>


  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import HorizontalDivider from '@/Shared/HorizontalDivider';
import draggable from 'vuedraggable';
import SessionLogo from '@/Pages/DiyWorkshop/Shared/SessionLogo';
import ProgressTabs from '@/Pages/ControlPanel/Workshops/Shared/ProgressTabs';
import TestmodeBadge from '@/Pages/ControlPanel/Shared/TestmodeBadge';

export default {
  components: {
    Layout,
    HorizontalDivider,
    draggable,
    SessionLogo,
    ProgressTabs,
    TestmodeBadge,
  },

  props: ['session', 'translations'],

  data() {
    return {
      form: this.$inertia.form({
        phases: this.session.phases,
        saveAsTemplate: false,
        templateName: '',
      }),
    };
  },

  watch: {
    form: {
      deep: true,
      handler(form) {
        if (form.saveAsTemplate) {
          this.$nextTick(() => {
            this.$refs.templateName.focus();
          });
        }
      },
    },
  },

  methods: {
    isPlaceholderQuestion(phase) {
      if (!phase.data?.is_placeholder_question) {
        return false;
      }

      if (phase.data.is_placeholder_question) {
        return true;
      }

      return false;
    },

    formattedQuestion(phase) {
      return String(phase.data.question).replaceAll('%BRANDNAME', phase.data?.brandname ?? this.session.brandname);
    },

    itemClasses(phase) {
      let classes = [];

      if (phase.type != 'question') {
        classes.push('bg-black text-gray-300 border-white opacity-100');
      } else {
        classes.push('bg-white border-gray-200 opacity-100');
      }

      return classes.join(' ');
    },

    handleTabClick(tab) {
      this.submit(tab);
    },

    submit(tab) {
      this.form.post(
        this.route('control-panel.workshops.review.store', {
          sessionUuid: this.session.uuid,
          tab: tab,
        }),
        {}
      );
    },
  },


  computed: {
    disabled() {
      if (!this.session.can_be_activated) {
        return true;  
      }

      // if (
      //   this.form.saveAsTemplate &&
      //   !this.form.templateName
      // ) {
      //   return true;
      // }

      return false;
    },

    headline() {
      if (this.session.session_type == 'workshop') {
        return `Workshop ${this.session.project_name || ''}`;
      }

      if (this.session.session_type == 'diy_workshop') {
        return `Umfrage ${this.session.project_name || ''}`;
      }

      return 'Workshops &amp; Umfragen';
    },
  },
};
</script>